import styled, { css } from 'styled-components';
import { ISelectListItemStyledProps } from './select.types';

export const SelectListStyled = styled.div`
  max-height: 360px;
  overflow-y: auto;
`;

export const SelectListItemStyled = styled.div<ISelectListItemStyledProps>`
  background-color: ${({ $isSelected, theme }) => $isSelected ? theme.colors.blue[5] : theme.colors.gray[0]};
  font-size: 14px;
  line-height: 20px;
  font-weight: 500;
  padding: 10px 16px;
  color: ${({ $isSelected, theme }) => $isSelected ? theme.colors.gray[90] : theme.colors.gray[50]};
  cursor: pointer;

  &:hover {
    background-color: ${({ theme }) => theme.colors.gray[3]};
    color: ${({ theme }) => theme.colors.gray[70]};
  }

  ${({ $isDisabled }) => $isDisabled && css`
    background-color: ${({ theme }) => theme.colors.gray[5]};
    color: ${({ theme }) => theme.colors.gray[20]};

    &:hover {
      background-color: ${({ theme }) => theme.colors.gray[5]};
      color: ${({ theme }) => theme.colors.gray[20]};
    }
  `};
`;
